import React from 'react'
import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'

import {
  PROFILE_SECURITY_BORDER_COLOR,
  PROFILE_SECURITY_HEADING_COLOR,
  PROFILE_SECURITY_SUBTITLE_COLOR
} from '../constants/profileSecurityConstants'

export default function ProfileSecurityModalShell({
  open,
  onClose,
  title,
  subtitle,
  children,
  actions,
  maxWidth = 'sm'
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          border: `1px solid ${PROFILE_SECURITY_BORDER_COLOR}`,
          overflow: 'hidden'
        }
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 2,
          px: 2.5,
          pt: 2.25,
          pb: 1.5
        }}
      >
        <Box>
          <Typography sx={{ fontSize: 16, fontWeight: 800, color: PROFILE_SECURITY_HEADING_COLOR }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography sx={{ fontSize: 13, color: PROFILE_SECURITY_SUBTITLE_COLOR, mt: 0.5 }}>
              {subtitle}
            </Typography>
          ) : null}
        </Box>
        <IconButton aria-label="Cerrar" onClick={onClose} size="small" sx={{ color: PROFILE_SECURITY_SUBTITLE_COLOR }}>
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <Divider sx={{ borderColor: PROFILE_SECURITY_BORDER_COLOR }} />
      <DialogContent sx={{ px: 2.5, py: 2.25 }}>{children}</DialogContent>
      {actions ? (
        <>
          <Divider sx={{ borderColor: PROFILE_SECURITY_BORDER_COLOR }} />
          <DialogActions sx={{ px: 2.5, py: 1.75 }}>{actions}</DialogActions>
        </>
      ) : null}
    </Dialog>
  )
}
